import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { formatCurrency } from '@monorepo/client-common';
import { DesignIcon } from '@monorepo/nova-icons';
import { Button, Stack, Typography, useTheme } from '@monorepo/nova-ui';
import { useGetEnvironment } from '../../../hooks';
import { useCalculateTotalAvailableCredit } from '../../../hooks/use-calculate-total-available-credit';
import BalanceDialog from '../../balance/balance-dialog';

export const BalanceButton = ({ userId }: { userId?: string } = {}) => {
  const theme = useTheme();
  const [searchParams, setSearchParams] = useSearchParams();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (searchParams.get('openCredits') === 'true') {
      setOpen(true);
      setSearchParams((prev) => {
        const next = new URLSearchParams(prev);
        next.delete('openCredits');
        return next;
      });
    }
  }, [searchParams, setSearchParams]);
  const { totalAvailable, refetch } = useCalculateTotalAvailableCredit(userId);
  const { is5ers } = useGetEnvironment();

  const handleOpen = () => {
    refetch(); // Refresh balance when opening (e.g. after admin added credits)
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        aria-label="Balance"
        sx={{ minWidth: 'unset !important', p: '0 !important' }}
        onClick={handleOpen}
      >
        <Stack
          sx={{
            flexDirection: 'row',
            alignItems: 'center',
            gap: theme.typography.pxToRem(6),
          }}
        >
          {is5ers ? (
            <DesignIcon
              iconName="Balance5ersLogo"
              useMuiSvgIcon={false}
              width={16}
              height={16}
            />
          ) : (
            <DesignIcon
              iconName="BalanceTTPLogo"
              useMuiSvgIcon={false}
              width={16}
              height={16}
            />
          )}
          <Typography
            sx={{
              color: theme.palette.text.primary,
              fontWeight: 500,
              fontSize: 18,
            }}
          >
            {formatCurrency(totalAvailable, {
              decimalPlaces: 2,
            })}
          </Typography>
        </Stack>
      </Button>
      <BalanceDialog open={open} onClose={handleClose} userId={userId} />
    </>
  );
};
